<template>
  <span
    class="badge bg-warning text-dark border border-dark border-2 position-absolute rounded-circle shadow fs-3 translate-middle p-2 ms-2"
    data-bs-toggle="tooltip"
    title="1st Place"
  >
    <i class="bi bi-trophy"></i>
  </span>
</template>

<script>
import { Tooltip } from "bootstrap";

export default {
  name: "TrophyIcon",
  methods: {
    initTooltips() {
      // Clear any previous tooltips
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        const instance = Tooltip.getInstance(el);
        if (instance) instance.dispose(); // remove old instance
        new Tooltip(el); // create new instance
      });
    }
  },
  mounted() {
    this.initTooltips();
  },
  beforeUnmount() {
    // Clean up tooltips on component destroy
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      const instance = Tooltip.getInstance(el);
      if (instance) instance.dispose();
    });
  }
  /* lifecycle hooks */
};
</script>
